export function sbmNewsListingFilterHandler() {
    const showFilter = $('.sbm-views-news-events .show_filter');
    const filterDiv = $('.sbm-views-news-events .view-filters');
    
    showFilter.once().on('click', function () {
        filterDiv.slideToggle();
    });
}